var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useState } from 'react';
import clsx from 'clsx';
import { useClipboard } from 'use-clipboard-copy';
import { Input } from '../Input/Input.js';
import { Link } from '../Link/index.js';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const FormControlInputCopy = forwardRef((props, ref) => {
    const { value, hideValue = false, controlLabels = {} } = props, rest = __rest(props, ["value", "hideValue", "controlLabels"]);
    const { layoutProps, inputProps } = extractLayoutProps(rest);
    const { show: showLabel = 'Show', hide: hideLabel = 'Hide', copy: copyLabel = 'Copy', copied: copiedLabel = 'Copied', } = controlLabels;
    const [copied, setCopied] = useState(false);
    const clipboard = useClipboard();
    const [showValue, setShowValue] = useState(!hideValue);
    const addon = hideValue ? (React.createElement("div", { className: "flex items-center h-full pe-2" },
        React.createElement(Link, { onClick: () => setShowValue(!showValue), variant: "neutral" }, showValue ? hideLabel : showLabel))) : null;
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps),
        React.createElement(Input, Object.assign({ ref: ref }, inputProps, { value: value, onClick: e => e.currentTarget.select(), type: showValue ? 'text' : 'password', trailingAddon: React.createElement("div", { className: "flex h-full divide-x divide-line-subdued" },
                addon,
                React.createElement("div", { className: clsx('flex items-center h-full', !!addon && 'ps-2') },
                    React.createElement(Link, { onClick: () => {
                            clipboard.copy(value);
                            setCopied(true);
                            setTimeout(() => setCopied(false), 2000);
                        }, variant: "neutral" }, copied ? copiedLabel : copyLabel))) }))));
});
//# sourceMappingURL=FormControlInputCopy.js.map